import React from 'react';
import { useSelector } from 'react-redux';
import { Attention } from '@yme/assets/icons';
import { AlertType } from '@yme/atoms/alert';
import { getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { AlertActionButton } from './AlertActionButton';
import { InformationAlertStyled } from './styled';
import { useInfoAlertClick } from './useInfoAlertClick';
export function InformationAlert({ message, link, dataTestId }) {
    const isRightToLeft = useSelector(getRTL);
    const { onInfoAlertClickHandler } = useInfoAlertClick({
        learnMoreLink: link,
    });
    const { t } = useTranslation();
    return (React.createElement(FlexWrapper, { mt: "20px", mb: "20px", flexDirection: "column" },
        React.createElement(InformationAlertStyled, { message: message, type: AlertType.MESSAGE, customIcon: Attention, isRightToLeft: isRightToLeft, dataTestId: dataTestId, action: link ? (React.createElement(AlertActionButton, { content: t('common_learnMore_link'), onClick: onInfoAlertClickHandler })) : null })));
}
